<template>
  <div class="staff-boxs">
    <div class="cont-top m-b-30 com-model flex flex-column align-initial flex-between">
      <div class="cont-title flex flex-between" style="padding-right: 40px">
        <div class="flex">
          组织架构
          <div class="primary-btn m-l-24" @click="goadd(1)">
            <i class="el-icon-plus m-r-10"/>新增员工
          </div>
        </div>
        <div class="primary-border-btn m-l-24" @click="gochangeadm">更换管理员</div>
      </div>
      <el-tabs class="ac-tabs" v-model="tabindex" @tab-click="handleClick">
        <el-tab-pane :index="index"
                     :label="item"
                     :name='index.toString()'
                     v-for="(item, index) in tabList"
                     :key="index"/>
      </el-tabs>
    </div>
    <div class="staffbox" style="padding-top: 4px;">
      <div class="com-model" style="padding: 32px 25px 40px;">
        <el-table :data="rowslist" style="width: 100%;" v-if="Number(tabindex) <= 1">
          <el-table-column prop="headImage" label="头像" width="150">
            <template slot-scope="scope">
              <img style="width: 40px; height: 40px; border-radius: 50%;"
                   :src="scope.row.headImage ? scope.row.headImage:'//oss.51ztx.com/face.png'"
                   alt=""/>
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="姓名" min-width="120"/>
          <el-table-column prop="phone" label="手机/账号" min-width="120"/>
          <el-table-column prop="workDesc" label="职位" min-width="120"/>
          <el-table-column label="操作" min-width="100">
            <template slot-scope="scope">
              <template v-if="Number(tabindex) === 0">
                <el-button class="staff-btn primary-border-btn"
                           @click="hrDisable(scope.row.id)"
                           type="text"
                           size="small">
                  停用
                </el-button>
                <el-button class="staff-btn primary-btn" @click="hrEdit(2,scope.row)" type="text" size="small">
                  编辑
                </el-button>
              </template>
              <template v-else>
                <el-button class="staff-btn primary-border-btn"
                           @click="hrDelete(scope.row.id)"
                           type="text"
                           size="small">
                  删除
                </el-button>
                <el-button class="staff-btn primary-btn" @click="hrEnable(scope.row.id)" type="text" size="small">
                  启用
                </el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="rowslist" style="width: 100%;" v-else>
          <el-table-column prop="headImage" label="头像" width="150">
            <template slot-scope="scope">
              <img :src="scope.row.headImage ? scope.row.headImage:'//oss.51ztx.com/face.png'" alt=""/>
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="姓名" min-width="120"/>
          <el-table-column prop="phone" label="手机/账号" min-width="120"/>
          <el-table-column prop="userId" label="验证信息" min-width="120"/>
          <el-table-column label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button class="staff-btn primary-border-btn" @click="hrDisable(scope.row.id)" type="text" size="small">
                拒绝
              </el-button>
              <el-button class="staff-btn primary-btn" @click="passJoin(scope.row.id)" type="text" size="small">
                通过
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="total"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pageNum"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"
                       style="margin-top: 40px;"/>
      </div>
    </div>
    <Modal :show="modalshow"
           @cancelHander="cancel"
           @conformHander="conform"
           :modal-title="confirmTitle"
           :cancel-button-text="canceTxt"
           :confirm-button-text="confirmTxt">
      <div slot="modal-content">
        <!-- 增加员工 -->
        <div v-if="modalType === 1">
          <div class="ztx-mess-item clearfix">
            <div class="clearfix">
              <div class="ztx-mess-name">手机</div>
              <input type="text" class="ztx-mess-inp" @blur="getisReg" v-model="phone">
            </div>
            <p class="ztx-mess-tx">{{phoneerror}}</p>
          </div>
          <div class="ztx-mess-item clearfix">
            <div class="clearfix">
              <div class="ztx-mess-name">姓名</div>
              <input type="text" class="ztx-mess-inp" v-model="nickName">
            </div>
            <p class="ztx-mess-tx"/>
          </div>
          <div class="ztx-mess-item clearfix">
            <div class="clearfix">
              <div class="ztx-mess-name">职位</div>
              <input type="text" class="ztx-mess-inp" v-model="workDesc">
            </div>
          </div>
          <div class="ztx-mess-item clearfix" v-if="!isreg">
            <div class="clearfix">
              <div class="ztx-mess-name">设置密码</div>
              <input type="password" class="ztx-mess-inp" v-model="password" autocomplete="new-password">
            </div>
          </div>
        </div>
        <div v-if="modalType === 2">
          <div class="ztx-mess-item clearfix">
            <div class="clearfix">
              <div class="ztx-mess-name">手机</div>
              <input type="text" class="ztx-mess-inp" v-model="itemPhone" readonly="readonly"/>
            </div>
            <p class="ztx-mess-tx"/>
          </div>
          <div class="ztx-mess-item clearfix">
            <div class="clearfix">
              <div class="ztx-mess-name">姓名</div>
              <input type="text" class="ztx-mess-inp" v-model="itemNickName"/>
            </div>
            <p class="ztx-mess-tx"/>
          </div>
          <div class="ztx-mess-item clearfix">
            <div class="clearfix">
              <div class="ztx-mess-name">职位</div>
              <input type="text" class="ztx-mess-inp" v-model="itemWorkDesc"/>
            </div>
            <p class="ztx-mess-tx"/>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
  import Modal from '../../components/Modal.vue';
  import Pageing from '../../components/Pageing.vue';

  const qs = require('qs');

  export default {
    data() {
      return {
        tabList: ['在职员工', '停用员工', '申请加入'],
        name: 123,
        rowslist: [],
        total: -1,
        tabindex: 0,
        modalshow: false,
        adminInfo: null,
        phone: '',
        nickName: '',
        workDesc: '',
        password: '',
        isreg: false, // 默认没有注册
        modalType: -1,
        confirmTitle: '',
        canceTxt: '',
        confirmTxt: '',
        itemPhone: '',
        itemNickName: '',
        itemWorkDesc: '',
        itemid: '',
        pageNum: 1,// 分页页码
        pageSize: 10,
        phoneerror: ''
      }
    },
    created() {
      this.pageEnabled();
    },
    components: {
      Modal: Modal,
      ztxPaging: Pageing
    },
    watch: {
      modalType(newVal) {
        if (newVal === 1) {
          this.confirmTitle = '添加HR';
          this.canceTxt = '取消添加';
          this.confirmTxt = '保存并返回';
        } else {
          this.confirmTitle = "编辑hr";
          this.canceTxt = '取消';
          this.confirmTxt = '保存并返回';
        }
      }
    },
    methods: {
      handleClick(type) {
        this.tabindex = type.name;
        this.pageNum = 1;
        this.tabswitchList(this.tabindex);
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.tabswitchList(this.tabindex);
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.tabswitchList(this.tabindex);
      },
      // 分页变化
      currentChange(val) {
        this.pageNum = val;
        this.tabswitchList(this.tabindex);
      },
      // 编辑hr
      hrEdit(val, item) {
        this.modalType = val;
        this.modalshow = true;
        this.itemPhone = item.phone;
        this.itemNickName = item.nickName;
        this.itemWorkDesc = item.workDesc;
        this.itemid = item.id;
      },
      cancel() {
        this.modalshow = false;
      },
      // 删除hr
      hrDelete(id) {
        let self = this;
        self.$ztxConfirm('确定要永久删除此员工吗，删除员工之后，删除之后将不可恢复。', '删除员工').then(() => {
          self.axios.get('/wapi/hr/delete?operedHrId=' + id).then(res => {
            if (res.success) {
              self.$message({
                type: 'success',
                message: '删除成功'
              });
              self.pageDisabled();
            }
          });
        }).catch();
      },
      conform() {
        if (this.modalType === 1) {
          let qdata = {
            phone: this.phone,
            nickName: this.nickName,
            workDesc: this.workDesc
          };
          if (!this.isreg) {
            qdata.password = this.password;
          }
          this.axios.post('/wapi/hr/create', qs.stringify(qdata)).then(res => {
            if (res.success) {
              this.modalshow = false;
              this.$message({
                type: 'success',
                message: '已添加'
              });
            }
            this.pageEnabled();
          });
        } else {
          let qdata = {
            nickName: this.itemNickName,
            workDesc: this.itemWorkDesc,
            hrId: this.itemid
          };
          this.axios.post('/wapi/hr/modify', qs.stringify(qdata)).then(res => {
            this.modalshow = false;
            if (res.success) {
              this.$message({
                type: 'success',
                message: '已修改'
              });
            }
            this.pageEnabled();
          });
        }
      },
      // 判断手机是否注册
      getisReg() {
        if (this.phone === '') {
          this.phoneerror = '请输入手机号';
        } else if (this.phone.length < 11) {
          this.phoneerror = '手机号码格式有误';
        } else {
          this.phoneerror = '';
          this.axios.get('/wapi/hr/isReg?phone=' + this.phone).then(res => {
            if (res.data.isReg === 1) {
              this.$message.warning(res.msg);
            }
            this.isreg = !!res.data.isReg;
          });
        }
      },
      // 停用员工
      hrDisable(id) {
        let self = this;
        self.$ztxConfirm('确定要停用此员工吗，停用员工之后，该员工将不再有效。', '停用员工').then(() => {
          let url = `/wapi/hr/disable?operedHrId=${id}`;
          self.axios.get(url).then(res => {
            if (res.success) {
              self.$message({
                type: 'success',
                message: '已停用'
              });
              self.pageEnabled();
            }
          }).catch();
        }).catch();
      },
      goadd(val) {
        this.modalType = val;
        this.modalshow = true;
        this.phone = '';
        this.password = '';
        this.nickName = '';
        this.workDesc = '';
        this.phoneerror = '';
        this.isreg = false;
      },
      //企业员工
      hrEnable(id) {
        let url = `/wapi/hr/enable?operedHrId=${id}`;
        this.axios.get(url).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '已启用'
            });
            this.pageDisabled();
          }
        });
      },
      // 员工通过
      passJoin(id) {
        let url = `/wapi/hr/passJoin?operedHrId=${id}`;
        this.axios.get(url).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '已通过'
            });
            this.pageApply();
          }
        });
      },
      tabswitchList(val) {
        const num = Number(val);
        if (num === 0) {
          this.pageEnabled();
        } else if (num === 1) {
          this.pageDisabled();
        } else {
          this.pageApply();
        }
      },
      // 启用的hr
      pageEnabled() {
        let url = '/wapi/hr/pageEnabled';
        this.axios.get(url).then(res => {
          this.rowslist = res.rows;
          this.total = res.total;
        });
      },
      // 禁用的hr
      pageDisabled() {
        let url = '/wapi/hr/pageDisabled';
        this.axios.get(url).then(res => {
          this.rowslist = res.rows;
          this.total = res.total;
        });
      },
      //分页查询HR申请
      pageApply() {
        let url = '/wapi/hr/pageApply';
        this.axios.get(url).then(res => {
          this.rowslist = res.rows;
          this.total = res.total;
        });
      },
      gochangeadm() {
        this.$router.push({ path: '/index/staff/changeAdm' });
      }
    }
  };
</script>

<style scoped lang="less">
  @import url("../../assets/less/base.less");
  @import url("../../assets/css/staff");

  .cont-top {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .staffbox {
    .com-model {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }

  .stafftable .staff-table th {
    border: none;
    height: 34px;
  }

  .stafftable .staff-table th div {
    height: 14px;
    font-size: 14px;
    color: #888;
    font-weight: 300;
    position: relative;
  }

  .stafftable .staff-table th div::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 12px;
    top: 1px;
    right: 0;
    display: block;
    background-color: #e5e5e5;
  }

  .ztx-message-box .ztx-messge-content .ztx-mess-tx {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// list.vue?5a15a8be